import { render, staticRenderFns } from "./repaymentPlanItem.vue?vue&type=template&id=63749090&scoped=true"
import script from "./repaymentPlanItem.vue?vue&type=script&lang=js"
export * from "./repaymentPlanItem.vue?vue&type=script&lang=js"
import style0 from "./repaymentPlanItem.vue?vue&type=style&index=0&id=63749090&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63749090",
  null
  
)

export default component.exports